import { useContext } from "react";
import { BentoVisit } from "@/components/ui/box-visit-context";
import type { VisitAddress } from "@/components/ui/box.schema";

export function SectionRepairVisit({ address, from, children }: { address: VisitAddress; from: string; children: string }) {
  const host = useContext(BentoVisit);
  return <button type="button" data-act="visit" data-visit-to={address} className="text-ui font-semibold text-primary hover:underline" aria-disabled={!host || undefined} onClick={() => host?.visit(address, { box: from })}>{children}</button>;
}
